import { MenuItem } from '@mui/material';
import { usePerDiemParams } from 'pages/PerDiemArchive/params';
import * as React from 'react';
import { Selector } from 'components/Selectors';
import { times } from './times';

export const TimeSelector: React.FC = () => {
  const { searchParams, setSearchParams } = usePerDiemParams();

  const items = times.map((time) => (
    <MenuItem key={time.key} value={time.key}>
      {time.name}
    </MenuItem>
  ));

  return (
    <Selector
      id="time-selector"
      label="Time"
      value={searchParams.time}
      onChange={(time) => setSearchParams({ time })}
      placeholder="Time"
      renderValue={(time) => times.find((t) => t.key === time)?.name || ''}
    >
      {items}
    </Selector>
  );
};
TimeSelector.displayName = 'Selector.Time';
